import { AppContext } from '../../../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { etchBrandThemeWithAboutCompany } from '../../index';
import { faFacebook, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faGlobe } from '@fortawesome/pro-light-svg-icons';
import { useContext } from 'react';

interface FooterCardProps {
    title: string;
    socialTitle: string;
    brandTheme?: etchBrandThemeWithAboutCompany;
}

const findLocalOrDefaultAbout = (brandTheme: etchBrandThemeWithAboutCompany | undefined, locale: string) => {
    const localeFound = brandTheme?.meetAboutCompany?.find((item) => item.locale === locale);
    if (brandTheme?.meetAboutCompany && localeFound) {
        return localeFound.text;
    }
    if (brandTheme?.meetAboutCompany) {
        return brandTheme?.meetAboutCompany.find((item) => item.default)?.text;
    }
    return '';
};

const FooterCard: React.FC<FooterCardProps> = ({ title, brandTheme, socialTitle }) => {
    const { selectedLanguage } = useContext(AppContext);
    const { linkedin = '', facebook = '', x = '', instagram = '', website = '' } = brandTheme ?? {};

    return (
        <div className="aboutContainer">
            <div className="leftSide">
                <h3 className="heading-1">{title}</h3>
                <div className="aboutCompanyArea">{findLocalOrDefaultAbout(brandTheme, selectedLanguage)}</div>
            </div>
            {(linkedin || facebook || x || instagram || website) && (
                <div className="rightSide">
                    <h3 className="heading-2">{socialTitle}</h3>
                    <ul className="socialContainer">
                        {linkedin && (
                            <a key={linkedin} href={linkedin} className="nostyle" target="_blank" rel="noreferrer">
                                <li className="socialItem">
                                    <div className="socialIcon">
                                        <FontAwesomeIcon icon={faLinkedinIn} />
                                    </div>
                                    LinkedIn
                                </li>
                            </a>
                        )}
                        {facebook && (
                            <a key={facebook} href={facebook} className="nostyle" target="_blank" rel="noreferrer">
                                <li className="socialItem">
                                    <div className="socialIcon">
                                        <FontAwesomeIcon icon={faFacebook} />
                                    </div>
                                    Facebook
                                </li>
                            </a>
                        )}
                        {x && (
                            <a key={x} href={x} className="nostyle" target="_blank" rel="noreferrer">
                                <li className="socialItem">
                                    <div className="socialIcon">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="16"
                                            width="16"
                                            viewBox="0 0 512 512"
                                        >
                                            <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
                                        </svg>
                                    </div>
                                    X (formerly known as Twitter)
                                </li>
                            </a>
                        )}
                        {instagram && (
                            <a key={instagram} href={instagram} className="nostyle" target="_blank" rel="noreferrer">
                                <li className="socialItem">
                                    <div className="socialIcon">
                                        <FontAwesomeIcon icon={faInstagram} />
                                    </div>
                                    Instagram
                                </li>
                            </a>
                        )}
                        {website && (
                            <a key={website} href={website} className="nostyle" target="_blank" rel="noreferrer">
                                <li className="socialItem">
                                    <div className="socialIcon">
                                        <FontAwesomeIcon icon={faGlobe} />
                                    </div>
                                    Website
                                </li>
                            </a>
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default FooterCard;
